
<p-toast></p-toast>
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div class="bpt-main-content-container" style="overflow: auto;padding-top: 10px;" *ngIf="accessToCourseCatalogue; else courseNotFound">

  <div class="mb-1">
    <p-button *ngIf="addCourseAccess" label="Add Course" id="addCourseButton" class="add-course-button" icon="fa fa-plus" iconPos="left"
      (onClick)="addCourse()"></p-button>
  </div>
  <app-course-slider *ngIf="isCourseSliderOpen" [isCourseSliderOpen]="isCourseSliderOpen"
    (isCourseSliderActive)="closeCourseSlider($event)"></app-course-slider>
  <app-course-catalogue-search [panelListScreen]="panelListScreen"></app-course-catalogue-search>
</div>

<ng-template #courseNotFound>
  <app-error [errorMessage]="courseCatalogueErrorMessage()"></app-error>
</ng-template>